"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var sli_react_metrics_1 = require("@cvent/sli-react-metrics");
var PageLoadProvider_1 = require("./PageLoadProvider");
var PageActionsProvider_1 = require("./PageActionsProvider");
var LoggerFactory_1 = require("./utils/LoggerFactory");
/**
 * This Component configures metrics reporting for your application and should wrap your
 * application's entry point component (most likely under /pages/_app) to make the metrics
 * api available anywhere within the code. Out of the box it will give you a log reporter used
 * for development and a newrelic and datadog logger client to send metrics in higher regions.
 *
 * @param metricProps
 * {
 *   baseData: Record<string, string | {}>,
 *   config: {
 *     excludeUrls?: string[],
 *     excludedPaths?: string[],
 *     environmentName: string,
 *     metricsEnabled: boolean
 *   },
 *   children: React.ReactNode
 * }
 *
 */
var Metrics = function (_a) {
    var baseData = _a.baseData, config = _a.config, children = _a.children, _b = _a.reporters, reporters = _b === void 0 ? [] : _b, _c = _a.delegateLogsToReporters, delegateLogsToReporters = _c === void 0 ? false : _c, _d = _a.includeWebVitals, includeWebVitals = _d === void 0 ? false : _d, _e = _a.customTimingLabel, customTimingLabel = _e === void 0 ? 'PGQLR' : _e, _f = _a.getPersistedDataCallback, getPersistedDataCallback = _f === void 0 ? sli_react_metrics_1.getPersistedData : _f, _g = _a.setPersistedDataCallback, setPersistedDataCallback = _g === void 0 ? sli_react_metrics_1.savePersistedData : _g;
    // Check if we should enable the logger debug mode
    if (config.environmentName === 'dev' || config.environmentName === 'development') {
        (0, LoggerFactory_1.enableDebugMode)();
    }
    return (React.createElement(sli_react_metrics_1.ReactMetrics, { baseData: baseData, config: config, reporters: reporters, delegateLogsToReporters: delegateLogsToReporters, getPersistedDataCallback: getPersistedDataCallback, setPersistedDataCallback: setPersistedDataCallback },
        React.createElement(PageLoadProvider_1.PageLoadProvider, { config: config, includeWebVitals: includeWebVitals, customTimingLabel: customTimingLabel },
            React.createElement(PageActionsProvider_1.PageActionsProvider, null, children))));
};
exports.default = Metrics;
